import { render, staticRenderFns } from "./WikiDeleteConfirm.vue?vue&type=template&id=6addc81d&"
import script from "./WikiDeleteConfirm.vue?vue&type=script&lang=js&"
export * from "./WikiDeleteConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports